// 3rd Party
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Components
import { HR, OCButton } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { UpOutlined } from 'opencare-crown';

import { selectDataClinic } from '../../connect/selectors';
import { PROFILE_ACHIEVEMENT_SECTION_TYPES } from '../../constants/constants';
import { getProviderAchievements } from '../../helpers/profile-helpers';
import AchievementsInfo from '../AchievementsInfo/AchievementsInfo';
import ProviderAboutText from '../ProviderAboutText/ProviderAboutText';
import ProviderInfoHeader from '../ProviderInfoHeader/ProviderInfoHeader';

// Other

import { InfoCardFooter, StyledCard } from './styled-components';

// Component
const ProviderInfoCard = ({ layout, providerId }) => {
  const clinic = useSelector(selectDataClinic);
  const [expanded, setExpanded] = useState(false);
  const provider = _.find(clinic.providers, p => p.id === providerId);
  const { doctor } = provider;
  const {
    about,
    metadata,
    name,
    primaryPhoto,
    questionResponses,
    specialties,
  } = doctor;

  const awards = getProviderAchievements(
    clinic.address,
    provider.onlineBooking === true,
    metadata,
    specialties,
    'Awards',
    PROFILE_ACHIEVEMENT_SECTION_TYPES.awards,
  );
  const educationCertifications = getProviderAchievements(
    clinic.address,
    provider.onlineBooking === true,
    metadata,
    specialties,
    'Education & Certifications',
    PROFILE_ACHIEVEMENT_SECTION_TYPES.educationCertifications,
  );

  const handleExpandToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <StyledCard>
      <ProviderInfoHeader
        expanded={expanded}
        layout={layout}
        name={name}
        onExpandToggle={handleExpandToggle}
        photo={primaryPhoto}
      />
      {expanded
        && (
          <>
            <HR border={`1px solid ${colors.nickel}`} margin="10px 0" />
            {(about || questionResponses.length > 0)
              && (
                <ProviderAboutText
                  about={about}
                  questionResponses={questionResponses}
                />
              )
            }
            <AchievementsInfo achievements={awards} title="Awards" />
            <AchievementsInfo
              achievements={educationCertifications}
              title="Education & Certifications"
            />
            <InfoCardFooter>
              <OCButton
                color={colors.darkBlue}
                fontSize="14px"
                fontWeight="600"
                margin="20px 0 0 0"
                onClick={handleExpandToggle}
                type="link"
              >
                <UpOutlined /> View less
              </OCButton>
            </InfoCardFooter>
          </>
        )
      }
    </StyledCard>
  );
};

ProviderInfoCard.propTypes = {
  layout: PropTypes.string,
  providerId: PropTypes.number,
};

export default ProviderInfoCard;
